export const LOGIN_PATH = 'login';
export const LOGOUT_PATH = 'logout';
export const SILENT_LOGIN_PATH = 'silent-login';
export const PROFILE_PATH = 'profile';
export const CALLBACK_PATH = 'callback';

/**
 * README: process.env.NEXT_PUBLIC_AUTH0_PROFILE || '/api/auth/me',
 */
export const AUTH0_PROFILE_DEFAULT_URL = `/api/auth/${PROFILE_PATH}`;

export const TOKEN_REFRESH_INTERVAL = 12 * 60 * 60 * 1000; // 12H
